import { Card, Status, Typography } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { twJoin } from 'tailwind-merge';
import { CONTACT_SUPPORT } from '@/consts/links';

export const ContactSupportStatusDescription = ({
  description,
  linkText,
}: {
  description?: string;
  linkText?: string;
}) => {
  const { t } = useTranslation(['status', 'general']);
  return (
    <Typography variant="bodyRegular">
      {description || `${t('contactSupport.description', { ns: 'general' })} `}
      <a className="underline" target="_blank" rel="noreferrer" href={CONTACT_SUPPORT}>
        {linkText || t('contactSupport.link', { ns: 'general' })}
      </a>
    </Typography>
  );
};

export const ContactSupportCard = ({
  title,
  description,
  linkText,
  buttonProps,
  isFullscreen = false,
}: {
  title?: string;
  description?: string;
  linkText?: string;
  buttonProps?: any;
  isFullscreen?: boolean;
}) => {
  const { t } = useTranslation(['status', 'general']);

  return (
    <div className={twJoin(isFullscreen && 'w-full h-full p-2')}>
      <Card>
        <Status buttonProps={buttonProps} type="error" title={title || t('general.error.title')}>
          <ContactSupportStatusDescription {...{ description, linkText }} />
        </Status>
      </Card>
    </div>
  );
};
